import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type { AppConfig } from '@/shared/domain'
import type { LoadConfig } from '@/modules/auth/use-cases'

export class EdgeLoadConfigRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadConfig = async () => {
    const request: HttpRequest<never> = { url: '/config' }
    try {
      return await this.httpClient.get<AppConfig>(request)
    } catch {
      return {}
    }
  }
}
